<template>
  <el-select
    v-model="departmentId"
    placeholder="请选择"
    :multiple="multiple"
    filterable
  >
    <el-option-group
      v-for="group in departmentList"
      :key="group.departmentId"
      :label="group.departmentName"
    >
      <el-option
        v-for="item in group.children"
        :key="item.departmentId"
        :label="item.departmentName"
        :value="item.departmentId"
      >
      </el-option>
    </el-option-group>
  </el-select>
</template>
<script>
import { post } from "../utils/request";

export default {
  name: "DepartmentSelect",
  props: ["allowMultiple"],
  data() {
    return {
      multiple: this.allowMultiple,
      departmentList: [],
      departmentId: [],
      departmentName: [],
      defaultProps: {
        children: "children",
        label: "departmentName",
        value: "departmentId",
      },
      type: "select",
      flag: false,
    };
  },
  watch: {
    departmentId(newVal, oldVal) {
      this.$emit("departmentId", this.departmentId);
    },
  },
  created() {
    this.depSearch();
  },
  methods: {
    /**
     * @description 查询所有部门科室
     * @function POST /department/search/tree
     *
     * @param departmentId
     */
    depSearch() {
      let deptManageInfo = sessionStorage.getItem("deptManageInfo");
      if (deptManageInfo != null && deptManageInfo != "") {
        this.departmentList = JSON.parse(deptManageInfo);
        return;
      }
      let regionIdList = [];
      regionIdList.push(
        JSON.parse(sessionStorage.getItem("regionInfo")).regionId
      );
      post("/department/search/tree", JSON.stringify(regionIdList)).then(
        (res) => {
          if (res.code == 200) {
            this.departmentList = JSON.parse(res.data.departmentList);
            sessionStorage.setItem(
              "deptManageInfo",
              JSON.stringify(this.departmentList)
            );
          }
        }
      );
    },
  },
};
</script>

<style scoped lang="scss">
</style>